import { render, staticRenderFns } from "./Appreciations.vue?vue&type=template&id=2bcbb9c5&"
import script from "./Appreciations.vue?vue&type=script&lang=js&"
export * from "./Appreciations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports